var render = function render(){var _vm=this,_c=_vm._self._c;return _c('result',{attrs:{"isSuccess":true,"content":false,"title":_vm.email,"description":_vm.description}},[_c('template',{slot:"action"},[_c('a-button',{attrs:{"size":"large","type":"primary"}},[_vm._v("查看邮箱")]),_c('a-button',{staticStyle:{"margin-left":"8px"},attrs:{"size":"large"},on:{"click":_vm.goHomeHandle}},[_vm._v("返回首页")])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }